"use client";
import React, { useMemo, useState } from "react";
import { DrawerButton, FmButton, FmDrawer, FmToast } from "@/ui-component";
import { loginOrNotNoJump } from "@/lib/commonService";
import { checkCanComment } from "@/src/models/products";
import { gaLoadedPromise, gaWriteReviewClick } from "@/src/utils/gtagEvents";
import {
    usePackageInfoContext,
    useProductDetailsContext,
} from "@/src/provider";
import { openUploadStore, signInModal } from "@/store";
import dynamic from "next/dynamic";
import classnames from "classnames";
import stl from "./productReview.module.scss";
import { IChildren } from "@/src/app/interface";
import { useTranslation } from "@/src/i18n/client";
import SelectlensModal from "../SelectContainer/SelectlensModal";
import ColorComfirmDrawer from "../ColorComfirmBtn/ColorComfirmDrawer";
// const WriteReviewForm = dynamic(import("../WriteReviewForm/WriteReviewForm"));
const ReviewList = dynamic(() => import("./ReviewList"));
interface IProps extends IChildren {
    commentNum: number;
}
const ProductReviewClient: React.FC<IProps> = (props) => {
    const { t } = useTranslation(["productDetail", "common", "review"]);
    const [showToast, setShowToast] = useState(false);
    const [productDetail] = useProductDetailsContext((state) => [
        state.productDetail,
    ]);
    const [isShowSelectModal, setIsShowSelectModal] = useState(false); // modal-toggle
    const [isShowColorSelect, setIsShowColorSelect] = useState(false);
    const { commentNum } = props;
    const [isPackage] = usePackageInfoContext((state) => [state.isPackage]);
    const isPackageMemo = useMemo(
        () => !!(isPackage && productDetail.meedPackage),
        [isPackage, productDetail.meedPackage],
    );

    const [isShowList, setIsShowList] = useState(false);
    const [showToastChildren, setShowToastChildren] = useState("");
    const [open, openUpload] = openUploadStore.useOpenUploadStore((state) => [
        state.open,
        state.openUpload,
    ]);
    const [openModal] = signInModal.useSignInModalStore((state) => [
        state.openModal,
    ]);

    const toggerShowList = () => {
        setIsShowList((prev) => !prev);
    };

    const openUploadTransfer = () => {
        if (!loginOrNotNoJump()) {
            openModal();
        } else {
            checkCommentAuth();
        }
    };

    const checkCommentAuth = () => {
        productDetail.products_id &&
            checkCanComment(productDetail.products_id)
                .then((res) => {
                    openUpload(false);
                })
                .catch((err) => {
                    setShowToast(true);
                    setShowToastChildren(err?.message);
                });
        //GA评价
        gaLoadedPromise()
            .then((res) => {
                gaWriteReviewClick();
            })
            .catch((e) => {
                console.log(e);
            });
    };

    return (
        <>
            <FmToast
                visible={showToast}
                seconds={3}
                type={"info"}
                onChange={(visible) => {
                    setShowToastChildren("");
                    setShowToast(visible);
                }}
            >
                {showToastChildren}
            </FmToast>
            {props.children[0]}
            {commentNum > 0 ? (
                <>
                    {props.children[1]}
                    {commentNum > 2 && (
                        <FmButton
                            size="medium"
                            onClick={toggerShowList}
                            style={{
                                display: "block",
                                margin: "0 auto",
                            }}
                        >
                            {t(`review:READ_ALL_REVIEWS`)}
                        </FmButton>
                    )}
                </>
            ) : (
                props.children[1]
            )}
            <div
                className={classnames(
                    "default_layout",
                    stl["write-and-review"],
                )}
            >
                <FmButton
                    onClick={openUploadTransfer}
                    icon="icon--ask"
                    iconClassName={stl["icon-ask-content"]}
                    size="medium"
                    style={{
                        marginTop: "0.2rem",
                        width: "auto",
                        minWidth: "3rem",
                    }}
                    variant="text"
                    iconLeft
                    contentClassName={stl["write-review-content"]}
                >
                    {t("common:btn.WriteAReview")}
                </FmButton>
            </div>
            <FmDrawer
                closeable
                open={isShowList}
                onClose={toggerShowList}
                anchor="bottom"
                fullHeight
                headerChildren={
                    <div
                        className={stl["modal-title"]}
                    >{`${t("productDetail:Reviews")}(${commentNum})`}</div>
                }
                headerClassName={stl["header"]}
                closeablePosition="right"
                className={stl["review-drawer"]}
                childrenClassName={stl["review-list-container"]}
                horizontal
                footerClassName={stl["bottom-line"]}
                footer={
                    <DrawerButton
                        buttonProps={[
                            {
                                children: t("common:btn.WriteAReview"),
                                onClick: openUploadTransfer,
                            },
                            {
                                children: isPackage
                                    ? t("productDetail:SelectLenses")
                                    : t("productDetail:SelectLenses"),
                                onClick: isPackage
                                    ? () => setIsShowSelectModal(true)
                                    : () => setIsShowColorSelect(true),
                            },
                        ]}
                    />
                }
            >
                {isShowList && (
                    <ReviewList
                        commentNum={commentNum}
                        openUploadTransfer={openUploadTransfer}
                        id={productDetail.products_id!}
                    />
                )}
            </FmDrawer>
            {isPackage ? (
                <SelectlensModal
                    visible={isShowSelectModal}
                    onClose={() => {
                        setIsShowSelectModal(false);
                    }}
                />
            ) : (
                <ColorComfirmDrawer
                    open={isShowColorSelect}
                    onClose={(open) => setIsShowColorSelect(open)}
                />
            )}

            {/* {open && <WriteReviewForm type={1} />} */}
        </>
    );
};

export default ProductReviewClient;
